import React from "react";
import { Button, Card, Flex, Space, Typography } from "antd";
import { summaryLine, trackerNotice } from "./rowResult";
import type { DownloadRowState } from "./rowResult";

interface Props {
  states: DownloadRowState[];
  folderUrl: string | null;
  trackerUrl: string | null;
  onNewDownload: () => void;
}

const RunSummary: React.FC<Props> = ({
  states,
  folderUrl,
  trackerUrl,
  onNewDownload,
}) => {
  const notice = trackerNotice(states);
  return (
    <Card>
      <Flex justify="space-between" align="center" wrap gap={16}>
        <div>
          <Typography.Text strong style={{ display: "block", fontSize: 18 }}>
            {summaryLine(states)}
          </Typography.Text>
          {notice ? (
            <Typography.Text type="secondary">{notice}</Typography.Text>
          ) : null}
        </div>
        <Space wrap>
          {folderUrl ? (
            <Button href={folderUrl} target="_blank" rel="noopener noreferrer">
              Abrir carpeta
            </Button>
          ) : null}
          {trackerUrl ? (
            <Button href={trackerUrl} target="_blank" rel="noopener noreferrer">
              Abrir tracker
            </Button>
          ) : null}
          <Button type="primary" onClick={onNewDownload}>
            Nueva descarga
          </Button>
        </Space>
      </Flex>
    </Card>
  );
};

export default RunSummary;
